const shuffle = (arr: any[]) => {
  let i = arr.length

  while (i) {
    const j = Math.floor(Math.random() * i--)
    ;[arr[j], arr[i]] = [arr[i], arr[j]]
  }

  return arr
}

export default shuffle
